{
  "shadow_review": {
    "title": "Revue Shadow",
    "subtitle": "Human-in-the-loop (ADR-0032 Phase 3). Tranche les verdicts ambigus et alimente le jeu d'entraînement en ground truth haute-confiance. Confirmer propose un label ; un second analyste approuve (4-eyes).",
    "loading": "Chargement…",
    "admin_only": "admin uniquement",
    "refresh": "Rafraîchir",
    "tab": {
      "disagreement": "Désaccord",
      "single_judge": "Juge isolé",
      "trusted": "Candidats confiance",
      "approvals": "Approbations"
    },
    "help": {
      "disagreement": "Events où le consensus LSTM↔GNN diverge — l'humain tranche l'ambiguïté.",
      "single_judge": "Un juge ML voit haut pendant que l'autre (mesuré) voit bas — candidats nouveaux patterns que le consensus discount.",
      "trusted": "Sources répétitivement suppressées (≥ 3× sur 30 j). Promouvoir = whitelist permanente (ADR-0008).",
      "approvals": "File 4-eyes — un second analyste (≠ proposeur) promeut un label proposé en human_labels."
    },
    "empty": {
      "events": "Aucun event dans cette file.",
      "trusted": "Aucun candidat à la promotion.",
      "approvals": "Aucune approbation en attente."
    },
    "pick_family": "famille…",
    "reason_ph": "raison (≥ 5 car., trace d'audit)",
    "confirm": "Confirmer",
    "confirm_benign": "Confirmer bénin",
    "verdict": {
      "attack": "Attaque",
      "benign": "Bénin"
    },
    "bulk": {
      "selected": "{{n}} sélectionné(s)",
      "select_all": "Tout sélectionner ({{n}})",
      "select_one": "Sélectionner cet event",
      "confirm": "Labelliser {{n}} event(s)",
      "clear": "Désélectionner",
      "too_many": "Lot limité à {{max}} events — réduisez la sélection.",
      "already_pending": "{{n}} event(s) ignoré(s) : une proposition est déjà en attente d'approbation."
    },
    "family_new": {
      "open": "Proposer une famille absente du catalogue",
      "slug_ph": "slug (ex. Ransomware)",
      "name_ph": "nom affiché",
      "rationale_ph": "justification (≥ 5 car.) — pourquoi cette famille manque",
      "create": "Créer",
      "cancel": "Annuler",
      "slug_hint": "Lettres, chiffres et « _ » uniquement, en commençant par une lettre (2–64).",
      "duplicate": "La famille « {{slug}} » existe déjà — la sélectionner, ou demander un regroupement à la plateforme.",
      "catalogue_error": "Catalogue des familles indisponible ({{msg}}) — labellisation impossible.",
      "exists_refresh_failed": "La famille « {{slug}} » existe déjà, mais le catalogue n'a pas pu être rafraîchi — recharger la page pour la sélectionner."
    },
    "skip": "Passer",
    "promote": "Promouvoir",
    "promote_prompt": "Raison pour faire confiance définitivement à {{ip}} (≥ 5 car.) :",
    "approve": "Approuver",
    "was": "était",
    "own_proposal": "votre proposition",
    "x_in_30d": "{{n}}× sur 30 j",
    "judge": {
      "score": "score",
      "div": "div",
      "dominant": "dominant"
    },
    "target_flow": "flow"
  },
  "host_baseline_policy": {
    "title": "Policy baseline host",
    "intro": "Seuils runtime du Host Behavioral Judge, par (tenant, rôle de sonde). Désactiver mute le juge pour ce rôle. k_enter/k_exit = hystérésis de suspicion (médiane + k·MAD) ; half_life = ramp de confiance cohorte au cold-start. Appliqué de façon asynchrone par le job d'analytics.",
    "col_role": "Rôle",
    "col_enabled": "Actif",
    "col_updated": "Modifié",
    "no_role": "(sans rôle)",
    "none": "Aucune policy — tous les rôles utilisent les défauts (k_enter 3.0 / k_exit 2.0 / half_life 24).",
    "k_enter_hint": "Entre en suspicion au-dessus de médiane + k_enter·MAD (0.5–10).",
    "k_exit_hint": "Sort de suspicion sous médiane + k_exit·MAD (0–10, ≤ k_enter).",
    "k_war_hint": "Variante war-mode (⚔) — utilisée à la place du k standard quand le tenant de ce rôle est en war mode. Défauts durcis 1.8 / 1.2.",
    "half_life_hint": "Intervalles propres pour 50% de confiance au profil propre vs cohorte (1–1000).",
    "reason_label": "Motif (optionnel, audité)",
    "reason_placeholder": "Pourquoi ce changement ? (consigné dans l'audit de policy)",
    "add_role_placeholder": "rôle sonde",
    "save": "Enregistrer",
    "add": "Ajouter",
    "confirm_delete": "Confirmer ?",
    "delete_hint": "Supprimer revient aux défauts pour ce rôle (peut réactiver un juge muté).",
    "version_hint": "policy_version — incrémenté par Reset pour re-seeder les baselines de ce rôle (lecture seule).",
    "reset_confirm": "Confirmer ?",
    "reset_hint": "Reset baselines : incrémente policy_version → le job re-seede (cold-start) les baselines des hosts de ce rôle au prochain passage. Audité.",
    "reset_done": "Reset baseline déposé — re-seed au prochain passage d'analytics.",
    "saved": "Policy enregistrée — appliquée au prochain passage d'analytics.",
    "deleted": "Policy supprimée.",
    "err_load": "Échec du chargement des policies.",
    "err_save": "Échec de l'enregistrement de la policy.",
    "err_invalid": "Valeurs invalides : k_enter 0.5–10, k_exit 0–10 (≤ k_enter), half_life 1–1000.",
    "err_forbidden": "Vous n'êtes pas autorisé à éditer cette policy.",
    "err_no_tenant": "Restreignez à un scope tenant pour ajouter une policy."
  },
  "fleet_shifts": {
    "title": "Détecteur de décalage fleet",
    "subtitle": "Dérive cohorte coordonnée — décalages audités et reset opérateur (ADR-0033).",
    "intro": "Une cohorte dilue un host compromis isolé, mais une attaque coordonnée sur une majorité de membres d'un rôle déplacerait le « normal » lui-même. Ce détecteur audite ces décalages et permet à un opérateur de reset une baseline cohorte décalée. Le reset est une décision humaine — jamais automatique — appliquée de façon asynchrone par le job d'analytics au passage suivant.",
    "shifts_title": "Décalages audités",
    "requests_title": "Requêtes de reset déposées",
    "none_shifts": "Aucun décalage fleet audité sur la fenêtre.",
    "none_requests": "Aucune requête de reset déposée.",
    "col_role": "Rôle",
    "col_season": "Saison",
    "col_trigger": "Déclencheur",
    "col_drift": "Dérive",
    "col_members": "Membres",
    "col_when": "Quand",
    "col_reason": "Motif",
    "col_by": "Par",
    "col_status": "État",
    "status_applied": "Appliqué",
    "status_pending": "En attente",
    "trigger_concurrent": "Activation concurrente",
    "trigger_drift": "Dérive lente",
    "members_fmt": "{{suspicious}}/{{established}} suspects",
    "reset_btn": "Reset baseline",
    "reset_title": "Reset baseline cohorte — {{role}} / {{season}}",
    "reset_hint": "Re-seede la baseline cohorte depuis le profil courant au prochain passage du job. Requis : un motif (audité).",
    "reason_placeholder": "Pourquoi reset cette baseline cohorte ? (ex. déploiement fleet-wide légitime à 14h00)",
    "submit": "Déposer le reset",
    "cancel": "Annuler",
    "filed_ok": "Requête de reset déposée — appliquée au prochain passage d'analytics.",
    "err_load": "Échec du chargement des décalages fleet.",
    "err_forbidden": "Vous n'êtes pas autorisé à reset cette cohorte.",
    "err_reason": "Un motif est requis.",
    "err_submit": "Échec du dépôt de la requête de reset."
  },
  "incidents": {
    "title": "Incidents",
    "subtitle": "Récits d'attaque — timelines post-path assemblées depuis les verdicts hot- et post-path (ADR-0048). Observation seule, pas une détection.",
    "filter_source": "IP source…",
    "family_any": "Toute famille",
    "multi_stage_only": "Multi-étapes uniquement",
    "clear": "Effacer",
    "loading": "Chargement des incidents…",
    "none": "Aucun incident dans le périmètre sélectionné.",
    "no_stages": "Aucune étape attribuée",
    "events_fmt": "{{count}} events",
    "related_fmt": "{{count}} events liés",
    "judges_label": "Juges",
    "origins_label": "Origines",
    "population_admitted": "Inclure les épisodes admis sans alerte",
    "admitted_no_alert": "Admis sans alerte",
    "admitted_via_fmt": "Admis via {{source}}",
    "err_load": "Échec du chargement des incidents.",
    "open_events_title": "Ouvrir les events de cette source dans Anomalies (fenêtre complète)"
  },
  "red_team": {
    "title": "Simulateur Red Team",
    "subtitle": "Simulation d'attaques automatisée contre le pipeline de détection LSTM + GNN",
    "internal_use_only": "Usage interne uniquement",
    "attack_scenarios": "Scénarios d'attaque",
    "expected_ttd": "TTD attendu : {{ttd}}",
    "simulating": "Simulation...",
    "run_one": "Lancer {{n}} scénario",
    "run_many": "Lancer {{n}} scénarios",
    "select_to_run": "Sélectionne des scénarios et lance la simulation",
    "detected": "DÉTECTÉ",
    "evaded": "ÉVADÉ",
    "lstm_score": "Score LSTM",
    "gnn_score": "Score GNN",
    "consensus": "Consensus",
    "ttd": "TTD",
    "packets": "Paquets",
    "needs_retraining": "Modèle à retrainer — à ajouter au dataset shadow",
    "stress": {
      "title": "Stress de normalisation (ADR-0015)",
      "subtitle_prefix": "Visualise le vecteur de features 10D produit par ",
      "subtitle_code1": "flow.rs::to_feature_vector",
      "subtitle_middle": " sur 5 scénarios hors-bornes. Aide à sentir où la normalisation v1.6 « écrase » du signal avant de pousser ces scénarios vers le ONNX (cf. ",
      "subtitle_code2": "make ai-stress-normalization",
      "subtitle_suffix": ").",
      "description_label": "Description :",
      "expected_label": "Attendu :",
      "vector_label": "Vecteur produit (10D)",
      "saturated_slots": "Slots saturés ({{n}})",
      "sentinel_slots": "Sentinels ({{n}})",
      "badge": {
        "ok": "ok",
        "saturated": "saturé",
        "sentinel": "sentinel",
        "nonfinite": "non-fini"
      }
    },
    "category": {
      "reconnaissance": "Reconnaissance",
      "exfiltration": "Exfiltration",
      "c2": "C2",
      "lateral_movement": "Mouvement latéral"
    }
  },
  "console_3d": {
    "title": "Console réseau 3D",
    "subtitle_prefix": "Topologie live — scores via ",
    "subtitle_suffix": " · clique un nœud pour l'explication XAI",
    "api_down": "API injoignable (fallback mock)",
    "live_status": "{{live}}/{{total}} nœuds live",
    "anomaly_score": "Score d'anomalie",
    "score_legend": {
      "critical": "> 0.8  Critique",
      "high": "> 0.5  Élevé",
      "medium": "> 0.3  Moyen",
      "normal": "≤ 0.3  Normal"
    },
    "empty_panel_hint": "Clique sur un nœud pour voir son dernier événement + explication XAI.",
    "nodes": "Nœuds",
    "selected_node": "Nœud sélectionné",
    "score": "Score",
    "live_time": "live · {{time}}",
    "fallback_no_event": "fallback (pas d'event récent pour cette IP)",
    "judge_label": "juge :",
    "explanation": "Explication",
    "webgl_unavailable_title": "Visualisation 3D indisponible",
    "webgl_unavailable_body": "Ce navigateur n'a pas de contexte WebGL. Le graphe est désactivé ; le panneau latéral et le flux d'événements restent utilisables.",
    "webgl_render_error_title": "Échec du rendu 3D",
    "webgl_render_error_body": "Une erreur de rendu a été capturée (asset invalide ou souci driver). Recharger la page pour réessayer.",
    "api_pending": "Connexion…"
  },
  "post_quantum": {
    "title": "Cryptographie post-quantique",
    "subtitle": "NIST FIPS 203 (ML-KEM) + FIPS 204 (ML-DSA) · appels backend réels",
    "quorum_ready": "Quorum prêt",
    "stats": {
      "public_key": "Clé publique",
      "secret_key": "Clé secrète",
      "ciphertext": "Ciphertext",
      "shared_secret": "Secret partagé",
      "signature": "Signature",
      "keygen": "Keygen",
      "ss_encap": "SS (encap)",
      "ss_decap": "SS (decap)",
      "encap_latency": "Latence encap",
      "decap_latency": "Latence decap",
      "sign_latency": "Latence sign",
      "size": "Taille"
    },
    "kem": {
      "title": "ML-KEM-768 — démo encapsulation de clé",
      "generate_keypair": "Générer keypair",
      "generating": "Génération...",
      "encapsulate": "Encapsuler",
      "encapsulating": "Encapsulation...",
      "decapsulate": "Décapsuler",
      "decapsulating": "Décapsulation...",
      "ss_match": "✓ Secrets partagés identiques — les 2 peers partagent 32 octets de keying material.",
      "ss_differ": "✗ Secrets partagés DIFFÉRENTS — attaque possible ou mauvaise keypair."
    },
    "sign": {
      "title": "ML-DSA-65 — démo signature",
      "generate_keypair": "Générer keypair de signature",
      "sign": "Signer",
      "signing": "Signature...",
      "verify": "Vérifier",
      "verifying": "Vérification...",
      "message": "Message",
      "valid": "valide",
      "invalid": "INVALIDE",
      "verdict_template": "Signature {{verdict}} — {{ms}}ms"
    }
  },
  "entropy": {
    "title": "Analyseur d'entropie",
    "subtitle": "Entropie de Shannon — H(X) = −Σ p(xᵢ) log₂ p(xᵢ). Unité : bits / octet.",
    "input_payload": "Payload d'entrée",
    "presets": {
      "Texte naturel": "Texte naturel",
      "JSON API": "JSON API",
      "Base64 (compressé)": "Base64 (compressé)",
      "Aléatoire (chiffré)": "Aléatoire (chiffré)",
      "Zéros (très structuré)": "Zéros (très structuré)"
    },
    "input_placeholder": "Collez du texte, du binaire (hex), du base64, …",
    "input_stats": "{{total}} octets analysés · {{distinct}} valeurs distinctes sur 256",
    "entropy_label": "Entropie",
    "entropy_max": "/ 8.000 bits",
    "anm_threshold_title": "Seuil ANM {{value}}",
    "verdict": {
      "quasi_random": "QUASI-ALÉATOIRE",
      "quasi_random_reason": "Distribution proche de l'uniforme — compression/chiffrement probable.",
      "above_anm": "AU-DESSUS DU SEUIL ANM",
      "above_anm_reason": "H ≥ {{value}} → candidat à une alerte d'exfiltration (combiné à ratio I/O).",
      "high": "HAUTE ENTROPIE",
      "high_reason": "Binaire compressé possible. À corréler avec le contexte.",
      "mixed": "MIXTE",
      "mixed_reason": "Texte, JSON, protocoles — profil standard.",
      "structured": "STRUCTURÉ",
      "structured_reason": "Très répétitif — probablement une séquence de padding, zéros, ou palette limitée."
    },
    "distribution_title": "Distribution (bins de 16 octets)",
    "baselines_title": "Repères — types de contenu",
    "your_payload": "Votre payload",
    "threshold_label": "seuil {{value}}",
    "baseline_labels": {
      "ascii_code_json": "ASCII, code, JSON",
      "natural_text": "Texte naturel FR/EN",
      "compressed_binary": "Binaire compressé",
      "random_encrypted": "Aléatoire / chiffré"
    },
    "pipeline_title": "Comment ANM utilise cette métrique",
    "pipeline": {
      "li1_strong": "proxy d'entropie",
      "li1_text1": " par flow (",
      "li1_code1": "FlowRecord::entropy_proxy",
      "li1_text2": " dans ",
      "li1_code2": "backend/ebpf/src/flow.rs",
      "li1_text3": ") — ratio bytes/paquet normalisé, pas Shannon complet pour rester no-FP en kernel eBPF.",
      "li1_prefix": "La sonde eBPF calcule une ",
      "li2_strong": "feature vector 8D",
      "li2_prefix": "La proxy rejoint le ",
      "li2_suffix": " (index 1) consommé par LSTM + GNN. Le LSTM détecte des séries d'entropie anormale, le GNN voit la corrélation topologique.",
      "li3_strong": "RuleJudge",
      "li3_prefix": "Le ",
      "li3_text1": " (troisième juge, anti-adversariel) checke aussi un seuil absolu : ",
      "li3_text2": " (proxy normalisée) → flag ",
      "li3_text3": " même si les juges ML sont silencieux.",
      "li4_strong": "ratio I/O",
      "li4_prefix": "Corrélation avec ",
      "li4_suffix": " : un flow à haute entropie + ratio sortant/entrant > 3× = signal fort d'exfiltration chiffrée."
    },
    "top_bytes_title": "Top 16 octets contribuant à H"
  },
  "lstm_gnn_wasm": {
    "title": "LSTM + GNN — Inférence WASM",
    "subtitle": "ONNX Runtime Web — inférence ML in-browser, zero round-trip",
    "lstm_judge": "LSTM Judge",
    "gnn_judge": "GNN Judge",
    "model_status": {
      "loaded": "chargé",
      "simulation": "simulation",
      "not_loaded": "non chargé"
    },
    "features_title": "Features du flux réseau",
    "feature_labels": {
      "packet_rate": "Taux de paquets",
      "byte_entropy": "Entropie octets",
      "flow_duration": "Durée du flux",
      "port_diversity": "Diversité de ports",
      "payload_ratio": "Ratio payload",
      "inter_arrival": "Inter-arrivée",
      "retransmits": "Retransmits",
      "ttl_variance": "Variance TTL"
    },
    "run_inference": "Lancer l'inférence",
    "inferring": "Inférence...",
    "results_title": "Résultats d'inférence",
    "consensus": "Consensus",
    "latency": "Latence d'inférence",
    "verdict": "Verdict",
    "verdict_critical": "CRITIQUE",
    "verdict_anomaly": "ANOMALIE",
    "verdict_normal": "NORMAL",
    "runtime": "Runtime",
    "runtime_value": "WASM (in-browser)",
    "attack_family": "Famille d'attaque",
    "empty_hint": "Ajuste les features et clique sur \"Lancer l'inférence\""
  },
  "federated": {
    "title": "Apprentissage fédéré",
    "subtitle": "Entraînement distribué préservant la confidentialité — DP ε={{epsilon}}",
    "round_label": "Round {{n}}",
    "kpi": {
      "active_nodes": "Nœuds actifs",
      "total_samples": "Total échantillons",
      "global_loss": "Loss globale",
      "dp_epsilon": "DP Epsilon"
    },
    "convergence": "Convergence loss globale",
    "participants": "Nœuds participants",
    "samples_suffix": "échantillons",
    "loss_suffix": "loss",
    "status": {
      "training": "training",
      "syncing": "syncing",
      "idle": "idle"
    }
  },
  "sbom": {
    "title": "Software Bill of Materials",
    "subtitle": "Graphe de dépendances + suivi CVE",
    "kpi": {
      "components": "Composants",
      "with_vulns": "Avec vulns",
      "total_cves": "Total CVEs",
      "licenses": "Licences"
    },
    "search_placeholder": "Rechercher un composant...",
    "severity": {
      "all": "Toutes sévérités",
      "clean": "Clean",
      "low": "Low",
      "medium": "Medium",
      "high": "High"
    },
    "th": {
      "component": "Composant",
      "version": "Version",
      "license": "Licence",
      "supplier": "Fournisseur",
      "vulnerabilities": "Vulnérabilités"
    },
    "clean_badge": "clean",
    "cve_count": "{{n}} CVE"
  },
  "adn": {
    "title": "Anomaly Detection Network",
    "subtitle_prefix": "LSTM + GNN dual-judge — live depuis ",
    "api_unreachable": "API injoignable",
    "live": "Live",
    "kpi": {
      "events_50": "Events (50 derniers)",
      "events": "Événements (fenêtre)",
      "critical": "Critical",
      "disagreement_xai": "Désaccord (XAI)"
    },
    "range": {
      "label": "Fenêtre",
      "1h": "1 h",
      "6h": "6 h",
      "24h": "24 h",
      "7d": "7 j",
      "30d": "30 j",
      "all": "Tout",
      "capped": "plafonné ({{n}})",
      "capped_title": "Comptes = minorants — seuls les {{n}} events les plus récemment ingérés sont chargés (l'API trie par ingestion, pas par date d'event), des events plus anciens de la fenêtre peuvent manquer.",
      "episode": "épisode {{from}} → {{to}}",
      "episode_title": "Fenêtre absolue d'un épisode, poussée au serveur (avant le LIMIT) — elle remplace la plage relative",
      "episode_clear": "Retirer la fenêtre d'épisode"
    },
    "scores_chart": "Scores individuels — fenêtre sélectionnée",
    "loading": "Chargement…",
    "no_event_to_display": "Aucun événement à afficher",
    "anomaly_events": "Anomaly events ({{n}})",
    "view_all": "Tous",
    "view_needs_review": "À revoir (XAI)",
    "filter": {
      "confidence": "Confidence",
      "severity": "Severity",
      "action": "Action",
      "judge": "Judge",
      "source_ip": "Source IP",
      "family": "Famille d'attaque",
      "min_score": "Score min"
    },
    "remove_filter_aria": "Retirer le filtre {{label}}",
    "clear_filters_title": "Effacer tous les filtres",
    "clear_filters_button": "clear",
    "empty": {
      "no_review": "Aucun event à revoir (aucune divergence signalée)",
      "no_match": "Aucun event ne match les {{n}} filtre(s) actif(s)",
      "no_recent": "Aucun event récent"
    },
    "click_for_xai": "Clique sur un événement pour voir son explication XAI et les policies associées.",
    "dctx": {
      "rule": {
        "C2_beacon": "balise C2 (rythme régulier)",
        "C2_hammer": "C2 en rafales (hammer)",
        "recon_horizontal": "reconnaissance horizontale",
        "recon_horizontal_outbound": "reconnaissance horizontale (sortante)",
        "exfil_volume": "exfiltration (volume)",
        "exfil_adaptive": "exfiltration adaptative (vs baseline)",
        "bruteforce_inbound": "brute-force entrant",
        "bruteforce_hammer": "brute-force (rafales)",
        "bruteforce_success": "brute-force réussi",
        "lateral_sequence": "mouvement latéral",
        "web_campaign": "campagne web"
      },
      "dir": {
        "inbound": "entrant",
        "outbound": "sortant"
      },
      "cvq": {
        "periodic": "quasi-périodique",
        "regular": "régulier",
        "irregular": "irrégulier",
        "bursty": "très irrégulier (rafales)"
      },
      "window": "fenêtre {{v}}",
      "beats": "{{v}} battements",
      "connections": "{{v}} connexions",
      "dst": "{{v}} destinations distinctes",
      "fails": "{{v}} tentatives échouées",
      "successes": "{{v}} succès",
      "cv": "CV {{v}}{{q}}",
      "volume_z": "z-score volume {{v}}",
      "port_entropy": "entropie de ports {{v}}",
      "score": "score {{v}} %",
      "action": "action : {{v}}",
      "raw": "détail brut",
      "dest": "→ {{v}}",
      "buckets": "{{v}} buckets",
      "exfil_bytes": "{{v}} exfiltrés",
      "traffic_bytes": "{{v}} de trafic"
    },
    "multi_host": "multi-hôte",
    "multi_host_hint": "La règle a mesuré {{count}} destinations pour cette source.",
    "incident_narrative": "Récit d'incident",
    "incident_narrative_title": "Ouvrir le récit post-path de cette source dans Incidents (stages ordonnés, tout l'horizon)"
  },
  "war_mode": {
    "title": "Cérémonie War Mode",
    "subtitle": "3 niveaux indépendants — seuils durcis dès qu'au moins un est actif. Chaque niveau exige 2 approbations distinctes (4-eyes).",
    "no_scope_available": "Aucun scope war-mode disponible — sélectionne un MSSP / tenant dans la barre de scope ou contacte ton admin.",
    "section": {
      "platform": "Platform",
      "mssp": "MSSP",
      "tenant": "Tenant",
      "platform_subtitle": "Override Ward³ vendor — affecte TOUS les MSSPs et leurs tenants",
      "mssp_subtitle": "Durcissement pour ce MSSP — affecte TOUS ses tenants (id : {{id}}…)",
      "tenant_subtitle": "Durcissement local au tenant {{id}}…"
    },
    "status": {
      "scope_label": "scope {{label}}",
      "api_unreachable": "API injoignable",
      "war_active": "WAR MODE {{label}} ACTIF",
      "stable": "Stable",
      "thresholds_hardened": "seuils durcis",
      "expires": "expire {{date}}",
      "approvals_count": "{{count}}/{{required}} approbations",
      "loading": "chargement…"
    },
    "give_approval": "Donner ton approbation ({{label}})",
    "your_approval": "Ton approbation",
    "active_since": "Active depuis",
    "reason_quote": "Raison :",
    "remove_approval": "Retirer mon approbation",
    "submitting": "…",
    "reason_placeholder": "Justifier l'activation {{label}} (10 caractères min)",
    "confirm_platform": "Je confirme que ce durcissement Platform impactera TOUS les MSSPs et leurs tenants.",
    "confirm_mssp": "Je confirme que ce durcissement MSSP impactera TOUS les tenants de ce MSSP.",
    "approve_button": "J'approuve War Mode {{label}}",
    "read_only_role": "Lecture seule — ton rôle ne te permet pas d'approuver à ce niveau.",
    "reason_too_short": "Justification trop courte (10 caractères min).",
    "confirm_required": "Coche la case de confirmation — l'impact dépasse ton scope direct.",
    "approval_recorded": "Approbation enregistrée.",
    "approval_revoked": "Approbation retirée.",
    "forbidden_act": "403 — Ton rôle ne permet pas d'agir sur ce scope.",
    "forbidden_revoke": "403 — Tu ne peux pas révoquer cette approbation.",
    "server_error": "Erreur serveur",
    "slot_label": "Slot {{n}}",
    "slot_admin": "admin #{{id}}…",
    "slot_expires": "expire {{time}}",
    "slot_waiting": "En attente…",
    "explanation": {
      "title": "Comment ça marche",
      "li1_strong": "3 niveaux indépendants",
      "li1_text": " — Platform (rouge), MSSP (orange), Tenant (jaune). Le seuil effectif côté ",
      "li1_code": "ingest_event",
      "li1_text2": " = OR sur les 3 flags, donc activer ",
      "li1_em": "n'importe lequel",
      "li1_text3": " des niveaux durcit le scoring pour les events qui matchent ce scope.",
      "li2_strong": "4-eyes principle",
      "li2_text": " — chaque niveau exige 2 admins distincts dans une fenêtre glissante de 1 h. Les approbations expirent automatiquement.",
      "li3": "Seuils durcis identiques aux 3 niveaux : block > 0.75, quarantine > 0.55, ratelimit > 0.3 (vs 0.9 / 0.7 / 0.5 en mode stable).",
      "li4": "Confirmation explicite obligatoire avant Platform / MSSP — l'UI force le check pour mitiger l'activation accidentelle (R21).",
      "li5_prefix": "Audit complet : chaque approbation/révocation est tracée en logs structurés. Pour le détail, requêter "
    }
  },
  "trusted_sources": {
    "title": "Sources de confiance",
    "subtitle": "Whitelist permanente — sources promues depuis suppressions répétées (≥ 3 sur 30 j). Aucune policy n'est dérivée pour ces IPs, même score 1.0. Le Layer 0 tague un flux quand son initiateur canonique (src) figure dans cette liste — sur l'initiateur, toutes directions (l'egress peut aussi taguer un initiateur local sortant) ; seul le drop Pattern A est limité à l'inbound.",
    "loading": "Chargement…",
    "admin_only": "admin uniquement",
    "promote": "promouvoir",
    "revoke": "revoke",
    "renew": "renew",
    "renew_title": "Renouveler 1 h",
    "cidr_badge": "CIDR",
    "x_in_30d": "{{n}}× sur 30j",
    "promoted_from": "{{n}}× suppress",
    "promoted_direct": "direct",
    "renewed_from": "renouvelée (#{{id}})",
    "initial": "initiale",
    "candidates_section": "Candidats à promotion",
    "candidates_help": "Sources avec ≥ 3 suppressions distinctes sur 30 j glissants. Promouvoir = whitelist permanente, à utiliser pour les FP structurels (backup, monitoring, audit récurrent).",
    "candidates_empty": "Aucun candidat. Une IP doit accumuler ≥ 3 suppressions sur 30 j pour apparaître ici.",
    "active_trusted_section": "Trusted actifs",
    "active_trusted_empty_prefix": "Aucune source trusted. Promeus une candidate ci-dessus, ou (admin) via ",
    "active_trusted_empty_code": "POST /api/trusted-sources",
    "active_trusted_empty_suffix": ".",
    "suppressions_section": "Suppressions actives",
    "suppressions_help_prefix": "Suppressions TTL'd transitoires (créées depuis le drawer ",
    "suppressions_help_code1": "/anomalies",
    "suppressions_help_middle": "). « Renew » crée une nouvelle suppression de 1 h en chaînant via ",
    "suppressions_help_code2": "renewed_from_id",
    "suppressions_help_suffix": " pour préserver l'historique d'audit.",
    "suppressions_empty_prefix": "Aucune suppression active. Les suppressions sont créées depuis le drawer d'event sur ",
    "suppressions_empty_code": "/anomalies",
    "suppressions_empty_suffix": ".",
    "prompts": {
      "promote": "Promouvoir {{ip}} en trusted ? Raison (≥ 5 caractères) :",
      "revoke_trusted": "Revoke trusted {{ip}} ? Les events score≥0.9 reprendront leur dérivation normale.",
      "revoke_suppression": "Revoke suppression {{ip}} ?"
    },
    "th": {
      "source_ip": "Source IP",
      "frequency": "Fréquence",
      "reasons": "Raisons",
      "last": "Dernière",
      "reason": "Raison",
      "promoted_from_h": "Promu depuis",
      "created": "Créé",
      "expires": "Expire",
      "origin": "Origine"
    }
  },
  "baselines": {
    "title": "Baselines",
    "subtitle_prefix": "Profils stateful long-terme par triplet (src, dst, port). Stats Welford en ligne (μ + σ paquets), heatmap 24h des heures actives. Alimente les flags ",
    "subtitle_suffix": " visibles dans <code>/anomalies</code>.",
    "hour_active": "{{h}}h UTC : actif",
    "hour_never_seen": "{{h}}h UTC : jamais vu",
    "drift_section": "Drift PSI baselines (par tenant)",
    "tenants_count_one": "{{count}} tenant",
    "tenants_count_other": "{{count}} tenants",
    "loading": "Chargement…",
    "drift_empty_prefix": "Aucune baseline encore. Phase 5c câblera ",
    "drift_empty_suffix": " pour calibrer la distribution PSI sur les 500 premiers samples de chaque tenant. L'inférence reste fonctionnelle mais sans alerte de drift par-client en attendant.",
    "tenant_label": "tenant {{prefix}}…",
    "features_calibrated": "{{n}} / 10 features calibrées",
    "back_to_top": "Retour au top",
    "triplets_for": "Triplets pour",
    "no_triplets": "Aucun triplet pour cette source.",
    "active_sources_24h": "Sources actives sur 24h",
    "no_baseline_prefix": "Aucune baseline encore. Le tracker démarre dès que des flows arrivent et que ",
    "no_baseline_suffix": " est configuré côté inference daemon.",
    "feature_distribution": "distribution feature {{n}}",
    "th": {
      "destination": "Destination",
      "port": "Port",
      "flows": "Flows",
      "packet_stats": "Stats packets",
      "bytes": "Bytes",
      "active_hours": "Heures actives (UTC)",
      "last": "Dernière",
      "source_ip": "Source IP",
      "distinct_dests": "Destinations distinctes",
      "total_flows": "Flows totaux",
      "total_bytes": "Bytes totaux",
      "last_activity": "Dernière activité"
    }
  },
  "family_thresholds": {
    "title": "Seuils par famille",
    "subtitle_part1": "Ajuste la sensibilité des actions Block/Quarantine par famille d'attaque pour ce tenant. ",
    "subtitle_strong": "Durcissement uniquement",
    "subtitle_part2": " — les overrides sont rejetés s'ils relâchent la baseline MSSP.",
    "refresh": "Actualiser",
    "loading": "Chargement…",
    "composition_hint_prefix": "Composition runtime : ",
    "composition_hint_suffix": ". Les actions standards (Block > 0.9 / Quarantine > 0.7 / RateLimit > 0.5) et war-mode (0.75 / 0.55 / 0.3) utilisent chacune leur propre multiplier — édite les 2 colonnes selon le contexte.",
    "th": {
      "family": "Famille",
      "baseline": "Baseline (MSSP)",
      "override_std": "Votre override (std)",
      "override_war": "Votre override (war)",
      "effective": "Effectif"
    },
    "not_set": "non défini",
    "override_badge": "override",
    "save": "Enregistrer",
    "saved": "Enregistré",
    "delete_title": "Supprimer l'override (revient à la baseline MSSP)",
    "show_audit": "Voir l'audit log",
    "hide_audit": "Masquer l'audit log",
    "audit": {
      "th_when": "Quand",
      "th_family": "Famille",
      "th_column": "Colonne",
      "th_change": "Changement",
      "th_action": "Action",
      "th_by": "Par",
      "loading": "Chargement de l'audit log…",
      "empty": "Aucune entrée d'audit pour ce tenant."
    },
    "errors": {
      "forbidden_get": "403 — pas autorisé.",
      "multiplier_range": "Multiplier doit être dans (0, {{max}}].",
      "below_baseline_std": "std doit être ≥ baseline MSSP ({{value}}).",
      "below_baseline_war": "war doit être ≥ baseline MSSP ({{value}}).",
      "relaxation_forbidden": "Tenant peut uniquement durcir au-dessus de la baseline.",
      "forbidden_write": "403 — pas autorisé à modifier cet override.",
      "delete_404": "Aucun override à supprimer."
    },
    "family_meta": {
      "DoS_DDoS": "Floods volumétriques / applicatifs",
      "BruteForce": "Password spraying",
      "Recon": "Scans de ports, énumération d'hôtes",
      "C2_Botnet": "Beacons command & control",
      "WebInjection": "SQLi, XSS, RCE",
      "Persist_Exploit": "Lateral movement",
      "Other": "Trafic non classifié (HybridJudge sous seuil ou LSTM legacy) — NE couvre PAS les typos/drift"
    }
  },
  "models": {
    "title": "Registre des modèles",
    "subtitle": "Modèles enregistrés · canary rollout · distribution observée",
    "canary": {
      "section": "Distribution canary",
      "metrics_unreachable": "/metrics inference injoignable — {{message}}. Vérifier que le port 9194 est exposé (compose dev) ou ajouter un proxy K8s.",
      "no_batch": "Pas encore de batch routé. Le canary se manifeste après ~32 flows scorés.",
      "split_summary": "stable {{stable}} · canary {{canary}}",
      "observed_ratio": "Ratio canary observé : <strong>{{pct}} %</strong> · Loi des grands nombres : convergence vers le pct configuré sur N≥100 batches."
    },
    "drift": {
      "section": "Drift PSI par feature (8 dim)",
      "thresholds": "seuils : < 0.1 stable · 0.1–0.2 surveiller · ≥ 0.2 drift significatif",
      "no_data": "Pas de mesure drift. Le tracker exige `ANM_DRIFT_WARMUP_SAMPLES` (défaut 500) avant publication.",
      "feature_label": "feature {{n}}"
    },
    "registry": {
      "section": "Registry",
      "endpoint_unavailable": "Endpoint <code>/api/models</code> non disponible — <code>docker compose exec inference anm-model-cli list</code> côté CLI en attendant la route HTTP.",
      "empty": "Aucun modèle enregistré. <code>make ai-register VERSION=…</code>",
      "th_active": "Actif",
      "th_pct": "%",
      "th_kind": "Type",
      "th_version": "Version",
      "th_acc": "Acc",
      "th_created": "Créé"
    }
  },
  "shadow_dashboard": {
    "title": "Tableau de bord Shadow Mode",
    "subtitle": "Collecte de trafic réel + pipeline d'étiquetage automatique",
    "collecting": "Collecte en cours",
    "kpi": {
      "events_visible": "Events visibles",
      "events_visible_hint": "les {{n}} plus récents (cap API)",
      "to_review": "À revoir (low/disag)",
      "to_review_hint": "confidence non-HIGH",
      "drift_canary": "Drift PSI · Canary",
      "drift_canary_link": "Voir",
      "drift_canary_hint": "8 features · ratio stable/canary"
    },
    "recent_events": "Events récents",
    "review_only_toggle": "À revoir uniquement (confidence low / disagreement)",
    "api_unreachable": "API /api/events injoignable — {{message}}",
    "unknown_error": "erreur inconnue",
    "loading": "Chargement…",
    "empty_review": "Aucun event à revoir (tous les juges sont d'accord)",
    "empty_recent": "Aucun event capturé récemment",
    "click_to_expand": "Cliquer pour voir l'explication",
    "no_xai": "Event antérieur à la migration XAI (pas d'explication stockée)."
  },
  "honey_data": {
    "title": "Honey Data",
    "subtitle": "Honeypot synthétique — capture les patterns d'attaque réels",
    "sessions_captured": "sessions capturées",
    "live_feed": "Flux d'attaques en direct",
    "capturing": "Capture en cours",
    "port": "Port {{n}}",
    "hits": "hits",
    "captured": "capturé",
    "status": {
      "active": "actif",
      "idle": "idle"
    }
  },
  "overview": {
    "title": "Vue d'ensemble Ward³",
    "subtitle": "Santé temps-réel · Cliquez une carte pour drill-down",
    "api_error": "Erreur API — {{message}}",
    "refreshed": "Rafraîchi",
    "kpi": {
      "events_per_min": "Events / min (1 min)",
      "events_in_window": "{{n}} sur la fenêtre",
      "critical": "Critiques (fenêtre)",
      "critical_hint": "{{anomaly}} anomalie · {{suspect}} suspect",
      "disagreement_rate": "Taux de désaccord",
      "disagreement_hint": "LSTM vs GNN — consensus fail-closed",
      "blocked_sources": "Sources bloquées",
      "in_quarantine": "{{n}} en quarantaine",
      "honey_hits": "Hits honeypot (24 h)",
      "honey_hits_hint": "0 hit attendu en nominal",
      "active_model": "Juges actifs",
      "active_model_hint": "Juges qui scorent sur la fenêtre"
    },
    "chart": {
      "title": "Volume d'events",
      "hint_window": "sur {{window}} · cap 1000 ingérés"
    },
    "loading": "Chargement…",
    "capped": "≥ {{n}} (plafonné)",
    "range": {
      "label": "Fenêtre",
      "1h": "1 h",
      "6h": "6 h",
      "24h": "24 h",
      "7d": "7 j",
      "30d": "30 j",
      "all": "Tout"
    },
    "posture": {
      "level": {
        "elevated": "ÉLEVÉ",
        "watch": "VIGILANCE",
        "nominal": "NOMINAL",
        "quiet": "CALME",
        "partial": "PARTIEL"
      },
      "summary": "{{rate}} events/min · {{window}} sur la fenêtre · {{disagree}} de désaccord · {{critical}} critiques · {{honey}} hits honeypot (24 h)"
    },
    "confidence": {
      "title": "Répartition de confiance",
      "high": "Haute",
      "low": "Basse",
      "disagreement": "Désaccord",
      "not_measured": "ML non mesuré",
      "unknown": "N/A"
    },
    "families": {
      "title": "Top familles d'attaque",
      "none": "Aucune famille sur la fenêtre",
      "link": "Filtrer les anomalies sur {{family}}"
    },
    "on_loaded": "sur {{n}} chargés"
  },
  "probe_setup": {
    "title": "Installation sonde",
    "subtitle": "Générez une commande one-liner pour enrôler une nouvelle sonde eBPF sur un hôte client.",
    "tenant_label": "Tenant",
    "ttl_label": "Validité du jeton",
    "ttl_24h": "24 heures",
    "ttl_48h": "48 heures",
    "ttl_7d": "7 jours",
    "generate": "Générer la commande d'installation",
    "regenerate": "Régénérer",
    "copy": "Copier",
    "copied": "Copié !",
    "copy_failed": "Presse-papiers indisponible — copiez la commande manuellement.",
    "expires": "Expire le {{when}}",
    "reuse_note": "Réutilisable jusqu'à expiration — à traiter comme un secret.",
    "loading": "Chargement…",
    "empty": "Aucun tenant pour ce MSSP pour l'instant.",
    "pick_mssp": "Sélectionnez un MSSP dans le sélecteur de périmètre (barre du haut) pour continuer.",
    "forbidden": "Le rôle mssp_admin ou platform_admin est requis pour générer des jetons d'enrôlement de sonde.",
    "errors": {
      "forbidden": "403 — vous n'êtes pas autorisé à générer un jeton de sonde pour ce tenant.",
      "forbidden_list": "403 — non autorisé à lister les tenants de ce MSSP.",
      "not_found": "404 — MSSP ou tenant introuvable.",
      "generic": "Échec de la génération de la commande d'installation."
    }
  },
  "campaigns": {
    "title": "Campagnes",
    "subtitle": "Clusters intra-tenant — sources alertantes convergeant vers la même destination rare (ADR-0048). Chaque membre porte son propre signal local (anti guilt-by-association). Observation seule.",
    "loading": "Chargement des campagnes…",
    "none": "Aucun cluster de campagne dans le périmètre sélectionné.",
    "dst_label": "Destination",
    "sources_fmt": "{{count}} sources",
    "families_label": "Familles",
    "origins_label": "Origines",
    "events_fmt": "{{count}} events",
    "err_load": "Échec du chargement des campagnes."
  },
  "model_health": {
    "title": "Santé Modèle",
    "subtitle": "Distributions modèle par tenant — ce que Prometheus fait mal (répartition des familles, abstention, disagreement, quantiles de score, sentinels par juge). Pré-vol avant un push ONNX. Observation seule.",
    "loading": "Chargement de la santé modèle…",
    "none": "Aucun instantané de santé modèle dans le périmètre sélectionné.",
    "events_fmt": "{{count}} events",
    "empty_family": "Famille vide",
    "disagreement": "Disagreement",
    "lstm_sentinel": "Sentinel LSTM",
    "gnn_sentinel": "Sentinel GNN",
    "score_p50": "Score p50",
    "score_p90": "Score p90",
    "score_p99": "Score p99",
    "err_load": "Échec du chargement de la santé modèle."
  },
  "cost_budget": {
    "title": "Coût / Budget de Risque",
    "subtitle": "Coût par tenant — volume de scan raw_flows, bruit aval, sources les plus bruyantes (ADR-0048). Observation seule.",
    "loading": "Chargement des coûts…",
    "none": "Aucun instantané de coût dans le périmètre sélectionné.",
    "col_tenant": "Tenant",
    "col_flows": "Flux",
    "col_bytes": "Octets",
    "col_probes": "Sondes",
    "col_alerts": "Alertes",
    "col_top_source": "Source #1",
    "col_window": "Fenêtre",
    "err_load": "Échec du chargement des coûts."
  },
  "suppression_suggestions": {
    "title": "Suppressions Suggérées",
    "subtitle": "Bruit faible récurrent jamais escaladé — candidats de suppression extraits d'anomaly_events (ADR-0048).",
    "suggestion_only": "Suggestion seule — cette vue n'écrit jamais de policy. Créez une vraie suppression depuis le module Suppressions.",
    "loading": "Chargement des suggestions…",
    "none": "Aucun candidat de suppression dans le périmètre sélectionné.",
    "col_signature": "Signature",
    "col_events": "Events",
    "col_days": "Jours",
    "col_max_score": "Score max",
    "col_family": "Famille type",
    "col_window": "Fenêtre",
    "err_load": "Échec du chargement des suggestions."
  },
  "arbiter": {
    "title": "Digital Twin Arbiter",
    "subtitle": "Arbitre post-décision de la zone grise (ADR-0050) : évidences longues, re-scoring au grain natif, dossiers rejouables, relabelling 4-eyes.",
    "not_a_judge": "Pas un juge — l'arbitre ne voit aucun flow temps réel, n'applique rien. Ses sorties : propositions 4-eyes et suggestions de suppression TTL.",
    "tab_queue": "File",
    "tab_cases": "Dossiers",
    "tab_suggestions": "Suggestions",
    "loading": "Chargement…",
    "err_load": "Échec du chargement des données arbitre.",
    "err_action": "Action échouée.",
    "queue_empty": "File vide — la zone grise est calme (ou ANM_TWIN_ARBITER est off).",
    "cases_empty": "Aucun dossier. Saisis l'arbitre depuis Anomalies (event) ou Flows (flow bénin).",
    "suggestions_empty": "Aucune suggestion de suppression (les verdicts benign en mode active en produisent).",
    "col_origin": "Origine",
    "col_target": "Cible",
    "col_source": "Source",
    "col_score": "Score",
    "col_status": "Statut",
    "col_created": "Créé",
    "col_model": "Modèle",
    "col_frac": "frac>seuil",
    "col_windows": "Fenêtres",
    "origin_manual": "manuel",
    "origin_auto": "auto",
    "window": "Fenêtre",
    "evidence_hash": "évidence",
    "anchor": "Ancre",
    "rescoring": "Re-scoring au grain natif (§D4-bis)",
    "rescoring_note": "Intrant du dossier uniquement — jamais une porte de verdict (D7.3). Distribution des scores sur fenêtres natives pleines ; la stabilité inter-fenêtres est l'information nouvelle.",
    "notes": "Notes (dégradations nommées)",
    "show_evidence": "Voir l'évidence brute (dossier rejouable)",
    "hide_evidence": "Masquer l'évidence brute",
    "case_not_found": "Dossier introuvable (purgé ou hors scope).",
    "view_case": "voir le dossier #{{id}}",
    "suggestion_only": "Suggestion seule : appliquer crée une vraie suppression via /api/suppressions (admin + RBAC) — jamais automatique.",
    "apply": "Appliquer",
    "dismiss": "Écarter",
    "applied": "Suppression créée pour {{ip}}.",
    "dismissed": "Suggestion écartée.",
    "already_decided": "Déjà décidée par un autre analyste.",
    "apply_prompt": "Raison de la suppression pour {{ip}} (≥ 5 chars, auditée) :",
    "admin_only": "admin uniquement",
    "applied_close_failed": "Suppression créée pour {{ip}}, mais la clôture de la suggestion a échoué — elle peut rester affichée comme suggérée.",
    "col_conformal": "conforme",
    "conformal_none": "Pas de p-value calibrée : couche conforme off, aucune strate à l'identité de cet artefact pour ce tenant, ou calibration en famine (voir les notes du dossier)."
  },
  "users": {
    "title": "Utilisateurs",
    "subtitle": "Comptes de ce tenant — création, changement de rôle, reset password. Les comptes cross-tenant (MSSP) se gèrent dans la console admin.",
    "new_user": "Nouvel utilisateur",
    "cancel": "Annuler",
    "email": "Email",
    "password": "Mot de passe",
    "role": "Rôle",
    "create": "Créer",
    "loading": "Chargement…",
    "empty": "Aucun utilisateur dans ce tenant.",
    "sa_badge": "service",
    "you_badge": "toi",
    "reset_password": "Réinitialiser le mot de passe",
    "delete": "Supprimer l'utilisateur",
    "roles": {
      "tenant_admin": "Admin tenant",
      "tenant_viewer": "Viewer (lecture seule)"
    },
    "prompts": {
      "reset_password": "Nouveau mot de passe pour {{email}} (8 caractères min.) — toutes ses sessions sont révoquées (les access tokens en vol sont coupés sous ~30 s) :",
      "delete": "Supprimer {{email}} ? Toutes ses sessions sont révoquées (les access tokens en vol sont coupés sous ~30 s)."
    },
    "errors": {
      "forbidden": "403 — pas autorisé à voir les utilisateurs de ce tenant.",
      "password_short": "Mot de passe trop court (8 caractères min.)."
    },
    "th": {
      "email": "Email",
      "role": "Rôle",
      "created": "Créé"
    }
  },
  "flows": {
    "title": "Flux",
    "subtitle": "Flux bruts capturés par la sonde (XDP ingress + tc-egress). Déplie un flux pour voir les alertes corrélées.",
    "refresh": "Rafraîchir",
    "loading": "Chargement…",
    "empty": "Aucun flux (capture egress/L7 active ? scope ?).",
    "count": "{{shown}} flux",
    "badge_alert": "Ce flux a une anomalie corrélée (déplie pour le détail)",
    "alerts_loading": "alertes…",
    "no_alert": "Aucune alerte corrélée à ce flux.",
    "open_in_anomalies": "Ouvrir dans Anomalies (source {{ip}})",
    "filter": {
      "src": "src_ip (initiateur)",
      "dst": "dst_ip",
      "service": "Service",
      "service_all": "Tous les services",
      "proto": "Protocole",
      "proto_all": "Tous les protocoles",
      "dir": "Direction",
      "dir_all": "Toutes directions",
      "dir_inbound": "Entrant",
      "dir_outbound": "Sortant",
      "only_alerts": "Avec alerte seulement"
    },
    "sort": {
      "label": "Tri",
      "start": "Récent",
      "bytes": "Octets",
      "packets": "Paquets"
    },
    "range": {
      "label": "Fenêtre",
      "1h": "1 h",
      "6h": "6 h",
      "24h": "24 h",
      "15m": "15 min"
    },
    "col": {
      "flow": "Flux (src → dst)",
      "proto": "Proto",
      "service": "Service",
      "dir": "Sens",
      "bytes": "Octets",
      "pkts": "Pqts",
      "l7": "L7",
      "start": "Début"
    },
    "error": {
      "forbidden": "Accès refusé.",
      "generic": "échec de récupération"
    },
    "refer": {
      "queued": "✓ saisine en file (#{{id}}) — dossier sous /arbiter",
      "duplicate": "déjà en file (#{{id}})",
      "button": "Saisir l'arbitre",
      "button_title": "Saisir le digital twin arbiter sur ce flow bénin (soupçon de faux négatif) — instruction post-décision hors budget hot-path",
      "err_cap": "cap manuel atteint",
      "err_off": "arbitre désactivé",
      "err_forbidden": "rôle admin requis",
      "err_generic": "saisine échouée"
    },
    "count_sample": "{{shown}} avec alerte · parmi {{total}} flux chargés",
    "no_alert_in_sample": "Aucun flux alerté parmi les {{n}} flux (récents) chargés — des flux alertés peuvent exister plus tôt dans la fenêtre.",
    "reset": "Réinitialiser les filtres"
  },
  "ip_detail": {
    "invalid": "« {{value}} » n'est pas une adresse IP exploitable.",
    "refresh": "Rafraîchir",
    "loading": "Chargement du profil IP…",
    "yes": "oui",
    "no": "non",
    "families": "Familles",
    "services": "Services",
    "range": {
      "label": "Fenêtre",
      "1h": "1 h",
      "6h": "6 h",
      "24h": "24 h"
    },
    "error": {
      "forbidden": "Accès refusé sur les anomalies (scope ?).",
      "generic": "Échec de récupération des anomalies."
    },
    "rep_mode": {
      "active": "appliquée",
      "shadow": "shadow"
    },
    "role": {
      "source": "émis",
      "destination": "reçu",
      "both": "boucle"
    },
    "badge": {
      "trusted": "Trusted",
      "trusted_hint": "Whitelist permanente — règle {{match}} · {{reason}}",
      "suppressed": "Suppression",
      "suppressed_hint": "Suppression active — règle {{match}} · classe {{cls}}",
      "policy": "Policy {{action}}",
      "policy_hint": "{{n}} action(s) NPI sur cette source",
      "none": "Aucun statut particulier.",
      "probe": "Sonde {{hostname}}",
      "probe_hint": "Sonde eBPF enrôlée dont l'IP interne rapportée est celle-ci (probe_certs.ip_address) — statut du certificat : {{status}}.",
      "partial": "Lecture partielle",
      "partial_hint": "Sources indisponibles : {{sources}}. Les indicateurs correspondants affichent « inconnu », pas « non »."
    },
    "tile": {
      "reputation": "Réputation",
      "reputation_hint": "Prior source ADR-0040 lu dans le decision_context de la dernière anomalie de cette source — c'est la réputation AU MOMENT de cette décision, pas la valeur live du snapshot NPI (aucun endpoint ne l'expose).",
      "reputation_neutral": "neutre",
      "last_activity": "Dernière activité",
      "first_seen": "Première observation",
      "first_seen_hint": "Première fois que Ward³ a observé cette adresse dans un flux sortant établi (ADR-0052). Ce n'est PAS « première apparition sur le réseau » : le registre ne connaît que les flux publiés puis consommés. Un « ≥ » signale une valeur bornée par le début d'historique du registre — l'adresse peut être plus ancienne.",
      "first_seen_gap": "Historique partiel : un repositionnement d'offset a été observé, une portion de l'historique manque.",
      "first_seen_absent": "aucune observation",
      "first_seen_absent_partial": "aucune observation (couverture partielle)",
      "first_seen_partial": "Certaines sondes sont encore en chauffe et ont été écartées : la couverture est partielle.",
      "first_seen_disabled": "registre inactif",
      "anomalies": "Anomalies",
      "anomalies_capped": "Cette IP atteint le plafond de 500 events : les comptes redeviennent des minorants.",
      "as_source": "src",
      "as_destination": "dst",
      "max_score": "Score max",
      "flows": "Flux bruts",
      "volume": "Volume",
      "peers": "Pairs distincts",
      "ports": "ports",
      "trusted": "Trusted IP",
      "suppression": "Suppression",
      "policies": "Policies NPI",
      "suppression_ttl": "expire dans {{ttl}}",
      "probe": "Sonde eBPF",
      "probe_hint": "Correspondance exacte sur `probe_certs.ip_address` (IP interne rapportée par la sonde à l'enrôlement). Une sonde révoquée ou expirée reste affichée, avec son statut.",
      "last_activity_partial": "Minorant : une des sources (anomalies / flux) n'a pas répondu — l'activité réelle peut être plus récente.",
      "flows_partial": "Un seul sens de flux a répondu (/api/flows filtre src_ip ou dst_ip, jamais les deux) : ces valeurs sont des minorants, pas des totaux."
    },
    "anomalies": {
      "title": "Anomalies",
      "side_all": "Toutes",
      "side_source": "En source",
      "side_destination": "En destination",
      "count": "{{n}} anomalie(s)",
      "capped": "plafond de {{n}} events atteint pour cette IP — comptes minorants",
      "empty": "Aucune anomalie sur la fenêtre.",
      "open": "Ouvrir dans Anomalies (détail XAI + actions)",
      "col": {
        "role": "Sens",
        "peer": "Pair",
        "score": "Score",
        "judge": "Juge",
        "family": "Famille",
        "confidence": "Confiance",
        "ts": "Horodatage"
      },
      "unavailable": "Anomalies indisponibles : la lecture de /api/events a échoué. La page ne peut ni les lister ni affirmer qu'il n'y en a pas."
    },
    "flows": {
      "title": "Flux bruts",
      "count": "{{n}} flux",
      "empty": "Aucun flux sur la fenêtre (capture active ? scope ?).",
      "col": {
        "role": "Sens",
        "flow": "Flux (src → dst)",
        "proto": "Proto",
        "service": "Service",
        "bytes": "Octets",
        "pkts": "Pqts",
        "start": "Début"
      },
      "open_emitted": "Flux émis",
      "open_emitted_hint": "Ouvrir Flux filtré sur src_ip = cette IP",
      "open_received": "Flux reçus",
      "open_received_hint": "Ouvrir Flux filtré sur dst_ip = cette IP (la vue Flux filtre un sens à la fois)",
      "unavailable": "Flux indisponibles : les deux sens (émis et reçus) ont échoué."
    },
    "truncated": "Affichage limité aux {{shown}} premières lignes sur {{total}}.",
    "probe_status": {
      "active": "active",
      "expired": "cert expiré",
      "revoked": "révoquée"
    },
    "unknown": "inconnu",
    "unknown_hint": "La lecture de cette source a échoué : la page ne peut pas affirmer l'absence. Rafraîchir, ou vérifier les droits sur l'endpoint.",
    "scope": {
      "subtitle": "Profil IP indisponible dans ce scope.",
      "blocked": "Une IP privée n'est unique qu'à l'intérieur d'un tenant : la même adresse peut désigner deux machines chez deux tenants. Votre scope effectif est « {{scope}} » — sélectionnez un tenant dans le sélecteur de scope pour ouvrir ce profil, sinon anomalies, flux, sonde et policies de plusieurs tenants seraient mélangés.",
      "kind": {
        "mssp": "MSSP",
        "platform": "plateforme",
        "tenant": "tenant"
      }
    },
    "source": {
      "trusted": "trusted sources",
      "suppressions": "suppressions",
      "policies": "policies",
      "probes": "sondes",
      "flows": "flux"
    },
    "incidents": {
      "title": "Épisodes de cette source",
      "count": "{{n}} épisode(s)",
      "out_of_window": "hors fenêtre de page — buckets de 6 h sur tout l'historique retenu",
      "open_label": "Ouvrir dans Incidents",
      "open": "Ouvrir Incidents filtré sur cette source (dont l'opt-in « admis sans alerte »)",
      "empty": "Aucun épisode ayant alerté pour cette source.",
      "unavailable": "Épisodes indisponibles : la lecture de /api/incidents a échoué. La page ne peut ni les lister ni affirmer qu'il n'y en a pas.",
      "stages_label": "Étapes",
      "no_stages": "aucune étape attribuée",
      "judges_label": "Juges",
      "origins_label": "Origines",
      "empty_hint": "L'élargissement « admis sans alerte » (ADR-0053 §B.3-bis) est demandé, mais un gate serveur peut l'ignorer sans que la réponse le dise : l'absence porte donc sur les épisodes ayant alerté, pas sur tous les épisodes.",
      "capped": "plafond de {{n}} épisodes atteint — compte minorant",
      "admitted_no_alert": "Admis sans alerte",
      "admitted_via_fmt": "Admis via {{source}}",
      "open_events_label": "Events de l'épisode",
      "open_events": "Ouvrir Anomalies sur la fenêtre exacte de cet épisode (filtre serveur) — une même source en produit plusieurs",
      "count_visible": "{{n}} épisode(s) visible(s)",
      "count_visible_hint": "Compte des épisodes RENDUS, pas de tous ceux qui existent : l'élargissement « admis sans alerte » est demandé mais un gate serveur peut l'ignorer sans que la réponse le signale. Un épisode admis sans alerte dans la liste prouverait que la population complète est servie."
    },
    "campaigns": {
      "title": "Campagnes où cette IP apparaît",
      "count": "{{n}} campagne(s)",
      "role_source": "en source",
      "role_destination": "en destination",
      "dst_label": "Destination",
      "sources_fmt": "{{count}} sources",
      "events_fmt": "{{count}} events",
      "empty": "Cette IP n'apparaît dans aucun cluster de campagne.",
      "empty_partial": "Aucun rapprochement sur les campagnes lues — l'absence n'est pas affirmable.",
      "partial_hint": "/api/campaigns n'a pas de filtre serveur : le rapprochement se fait sur une page bornée, et chaque campagne borne aussi sa propre liste de sources. Une campagne au-delà de ces plafonds resterait invisible ici.",
      "unavailable": "Campagnes indisponibles : la lecture de /api/campaigns a échoué. La page ne peut ni les lister ni affirmer qu'il n'y en a pas.",
      "partial": "couverture partielle"
    }
  },
  "novelty": {
    "title": "Candidats nouveauté",
    "subtitle": "File de revue des faux négatifs (ADR-0053 §F) : des sources qui ont vu du nouveau et n'ont déclenché aucune alerte. Une proposition de travail, pas une détection — le verdict reste humain et passe par le 4-eyes.",
    "filter_source": "IP source…",
    "detector_any": "Tous les détecteurs",
    "detector_pair_seen": "Couple neuf",
    "detector_fingerprint": "Empreinte neuve",
    "clear": "Effacer",
    "loading": "Chargement des candidats…",
    "none": "Aucun candidat dans le périmètre. Une file vide est un état légitime — un registre de couples neuf ou une sonde en warm-up n'en produit aucun.",
    "count_fmt": "{{count}} observations nouvelles",
    "err_load": "Échec du chargement des candidats.",
    "hide_reviewed": "Masquer ce qui est instruit",
    "all_reviewed": "Tous les candidats de cette page sont déjà instruits.",
    "state_pending": "En attente d'un second analyste",
    "state_labelled": "Labellisé",
    "prev": "Précédent",
    "next": "Suivant",
    "page_fmt": "Page {{page}}"
  },
  "incident_label": {
    "propose": "Proposer un label",
    "verdict": "Verdict",
    "verdict_attack": "Attaque",
    "verdict_benign": "Bénin (vrai négatif)",
    "family": "Famille",
    "family_pick": "Choisir une famille…",
    "reason_ph": "Pourquoi ? (trace d'audit, 5–2000 car.)",
    "pending_approval": "Proposé — en attente d'un second analyste",
    "err_conflict": "Déjà proposé pour cet épisode, ou l'épisode ne porte pas encore de provenance d'admission.",
    "err_not_found": "Épisode introuvable dans ce périmètre (il a pu expirer — rétention 30 jours).",
    "err_submit": "Échec de l'envoi de la proposition."
  }
}
